require('./hireCardRevolvingError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const {
    KNOWN_ERROR_CODE,
    REJECTED,
    LOW_CREDIT_SCORE
} = require('constants/hireCardSubmitScenarios');
const { PROC_CARD_REVOLVING } = require('utilities/tagging');

class HireCardRevolvingError extends React.Component {
    buildTexts() {
        const { immHireCardRevolving, hireRestrictionFlag } = this.props;
        let titleKey = 'hireCardRevolving-errorTitleGeneric';
        let textElement = (
            <div className="hire-card-revolving-error__text">
                <FormattedText value="hireCardRevolving-errorTextGeneric" />
            </div>
        );

        if (immHireCardRevolving.get('errorScoring') || !immHireCardRevolving.get('enabled')){
            textElement = (
                <div className="row hire-card-revolving-error__text">
                    <FormattedText
                        className="col-xs-12"
                        value="hireCardRevolving-scoringError"
                    />
                </div>
            );
        } else {
            switch (immHireCardRevolving.get('hiringStatus')) {
                case KNOWN_ERROR_CODE:
                    titleKey = 'hireCardRevolving-errorTitleAlreadyRequested';
                    textElement = (
                        <div className="row hire-card-revolving-error__text">
                            <p className="col-xs-12 hire-card-revolving-error__text--margin-bottom">
                                <FormattedText
                                    value={`hireCreditErrors-${immHireCardRevolving.get('errorMsg')}`}
                                />
                            </p>
                            <FormattedText
                                className="col-xs-12"
                                value="hireCardRevolving-errorTextCallUs"
                            />
                            <span className="col-xs-12 hire-card-revolving-error__phone">
                                <i className="hire-card-revolving-error__phone-icon icon icon-s-llamar" />
                                <FormattedText value="hireCardRevolving-phoneNumberClients" />
                            </span>
                        </div>
                    );
                    break;
                case REJECTED:
                    titleKey = 'hireCardRevolving-errorTitleRejected';
                    textElement = (
                        <div className="row hire-card-revolving-error__text">
                            <FormattedText
                                className="col-xs-12"
                                value="hireCardRevolving-errorTextCallUs"
                            />
                            <span className="col-xs-12 hire-card-revolving-error__phone">
                                <i className="hire-card-revolving-error__phone-icon icon icon-s-llamar" />
                                <FormattedText value="hireCardRevolving-phoneNumberClients" />
                            </span>
                        </div>
                    );
                    break;
                case LOW_CREDIT_SCORE:
                    titleKey = 'hireCardRevolving-errorTitleLowCreditScoreUpdated';
                    textElement = (
                        <div>
                            <div className="hire-card-revolving-error__text hire-card-revolving-error__text--margin-bottom">
                                <FormattedText
                                    value="hireCardRevolving-hireCardRevolving_lowCreditScoreMessage_updated"
                                />
                            </div>
                        </div>
                    );
                    break;
            }
        }
        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount" />
        }

        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { processDetail, hireRestrictionFlag } = this.props;
        const { textElement, titleKey } = this.buildTexts();
        const goBackButton = hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        } : {
            label: (
                <FormattedText
                    format="uppercase"
                    value="hireCardRevolving-errorBackButtonText"
                />
            ),
            url: '/myprofile/global'
        };
        const cancleButton ={
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionCancleButtonText"
                />
            ),
            url: '/myprofile/cards'
            };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                processType={PROC_CARD_REVOLVING}
                cancleButton={cancleButton}
            >
                <article className="hire-card-revolving-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

HireCardRevolvingError.propTypes = {
    immHireCardRevolving: PropTypes.object.isRequired,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool
};

HireCardRevolvingError.defaultProps =
{
    hireRestrictionFlag : false
}

module.exports = HireCardRevolvingError;
